import { observable, computed, action } from 'mobx'

class Task {

  handler = () => {}

  @observable results = []
  @observable successResults = []
  @observable errorResults = []

  @observable defaultValue = null

  @observable __promise = null

  @computed
  get isRunning() {
    return !!this.__promise
  }

  @computed
  get result() {
    return this.successResults[this.successResults.length - 1] || this.defaultValue
  }

  @computed
  get promise() {
    return this.__promise
  }

  @computed
  get executionCount() {
    return this.results.length
  }

  constructor(handler = () => {}, { defaultValue = null }) {
    this.defaultValue = defaultValue
    this.handler = handler
  }

  @action.bound
  perform() {
    if (!this.isRunning)
      this.__promise = this.handler(...arguments)
        .then(result => {
          this.successResults.push(result)
          return result
        })
        .catch(error => {
          this.errorResults.push(error)
          throw error
        })
        .finally(result => {
          this.results.push(result)
          this.__promise = null
        })
    return this.promise
  }

  valueOf() {
    return this.result
  }

}

export default function task(handler, options = {}) {
  return new Task(handler, options)
}



// WEBPACK FOOTER //
// ./src/helpers/task.js